import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.plugins.register(ChartDataLabels);

export const chartPageHeader = () => {
  (function($) {
    if ($("body").is(".page-node-type-chart-pages")) {
      // relocate header

      if ($("#chartPageHeader").length > 0) {
        let headerDetail = $("#chartPageHeader").clone();
        $("#chartPageHeader").remove();
        headerDetail.insertBefore("#block-breadcrumbs");
      }
    }
  })(jQuery);
};

/**
 * Init pie chart
 */
export const chartPagePieChart = () => {
  if (document.querySelector("#totalPieChart") === null) {
    return;
  }
  let totalPieChart = parseInt(document.querySelector("#totalPieChart").value);
  let pieLabel = [];
  let pieValue = [];

  if (totalPieChart > 0) {
    for (let i = 1; i <= totalPieChart; i++) {
      pieLabel = [];
      pieValue = [];

      for (
        let j = 0;
        j < document.querySelectorAll(`.pie-chart-label-${i}`).length;
        j++
      ) {
        pieLabel.push(
          document.querySelectorAll(`.pie-chart-label-${i}`)[j].value
        );
        pieValue.push(
          parseInt(document.querySelectorAll(`.pie-chart-value-${i}`)[j].value)
        );
      }

      var ctx = document.getElementById(`chartContainer${i}`).getContext("2d");
      const data = {
        labels: pieLabel,
        datasets: [
          {
            label: "My First Dataset",
            data: pieValue,
            backgroundColor: ["#E82A0E", "#EF6A57", "#F6AA9F"],
            borderColor: ["#E82A0E", "#EF6A57", "#F6AA9F"],
            hoverOffset: 4
          }
        ]
      };

      var myChart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "pie",
        data: data,
        options: {
          plugins: {
            // Change options for ALL labels of THIS CHART
            datalabels: {
              color: "#fff",
              formatter: function(value, context) {
                return `${value} %\n${
                  context.chart.data.labels[context.dataIndex]
                }`;
              },
              textAlign: "center"
            }
          },
          legend: {
            display: false
          }
        }
      });
    }
  }
};

/**
 * Init bar chart
 */
export const pageBarChart = () => {
  if (document.querySelector("#totalBarChart") === null) {
    return;
  }

  let totalBarChart = parseInt(document.querySelector("#totalBarChart").value);

  let barLabel = [];
  let barValue = [];
  let barBackgroundColor = [];
  let barHoverBackgroundColor = [];

  if (totalBarChart > 0) {
    for (let i = 1; i <= totalBarChart; i++) {
      barLabel = [];
      barValue = [];
      barBackgroundColor = [];
      barHoverBackgroundColor = [];

      for (
        let j = 0;
        j < document.querySelectorAll(`.bar-chart-index-${i}`).length;
        j++
      ) {
        barLabel.push(
          document.querySelectorAll(`.bar-chart-index-${i}`)[j].value
        );
        barValue.push(
          parseInt(document.querySelectorAll(`.bar-chart-value-${i}`)[j].value)
        );
        barBackgroundColor.push("#ED553E");
        barHoverBackgroundColor.push("#F39486");
      }

      var ctx = document.getElementById(`barContainer${i}`).getContext("2d");

      const data = {
        labels: barLabel,
        datasets: [
          {
            data: barValue,
            backgroundColor: barBackgroundColor,
            hoverOffset: 4,
            hoverBackgroundColor: barHoverBackgroundColor,
            label: "",
            order: 0
          }
        ]
      };

      var myChart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "bar",
        data: data,
        options: {
          plugins: {
            // Change options for ALL labels of THIS CHART
            datalabels: {
              color: "#fff",
              formatter: function(value, context) {
                return ``;
              },
              textAlign: "center"
            }
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      });
    }
  }
};
